import * as React from 'react';
import { Box, Heading, Text } from '@wix/design-system';
import { pageHeaderDataHooks } from './data-hooks';

export interface PageHeaderProps {
  secondaryTitle?: string;
  primaryTitle?: string;
  description?: string;
}

export function PageHeader({
  secondaryTitle,
  primaryTitle,
  description,
}: PageHeaderProps) {
  return (
    <Box dataHook={pageHeaderDataHooks.container} align="space-between">
      <Box direction="vertical">
        {secondaryTitle && (
          <Box marginTop="6px">
            <Heading
              dataHook={pageHeaderDataHooks.secondaryTitle}
              size="small"
              as="h1"
            >
              {secondaryTitle}
            </Heading>
          </Box>
        )}
        <Heading
          dataHook={pageHeaderDataHooks.primaryTitle}
          size="extraLarge"
          as="h2"
        >
          {primaryTitle}
        </Heading>
        <Box marginTop="6px">
          {description && (
            <Text
              dataHook={pageHeaderDataHooks.description}
              size="medium"
              weight="thin"
            >
              {description}
            </Text>
          )}
        </Box>
      </Box>
    </Box>
  );
}
